import React from 'react';

import { CurrencySymbols } from 'src/constants/currencySymbols';
import { TaxCodeByCurrency } from 'src/constants/taxCodeByCurrency';
import { Currencies, CountryCode } from 'src/enums';

import { TotalPriceInterface } from './BookingSummary.interface';
import * as S from './BookingSummaryCategory.style';
import { BookingSummaryCategorySection } from './BookingSummaryCategorySection';

import { numberToDecimalString } from '../../../utils';

export const BookingSummaryPaymentSection = ({
  totalPrice,
  countryCode,
  currency,
  isExternalAgent,
  hideDynamicLiability,
}: {
  totalPrice: TotalPriceInterface;
  countryCode: CountryCode;
  currency: Currencies;
  isExternalAgent: boolean;
  hideDynamicLiability?: boolean;
}) => {
  if (!totalPrice) {
    return (
      <S.BookingSummaryCategoryContainer>
        Error
      </S.BookingSummaryCategoryContainer>
    );
  }

  const {
    received,
    balance,
    totalPrice: price,
    taxAmount,
    liability,
  } = totalPrice;

  const currencySymbol =
    CurrencySymbols[currency] ?? CurrencySymbols[Currencies.NZD];
  const taxCode =
    TaxCodeByCurrency[currency] ?? TaxCodeByCurrency[Currencies.NZD];

  return (
    <S.BookingSummaryCategoryContainer>
      <S.BookingSummaryCategoryTitle>PAYMENTS</S.BookingSummaryCategoryTitle>
      {!isExternalAgent && (
        <>
          <BookingSummaryCategorySection
            name="Payment received"
            netPrice={received}
            showNetPrice
            currency={currency}
            showCurrency
          />
          <BookingSummaryCategorySection
            name="Trip total"
            netPrice={price}
            showNetPrice
            currency={currency}
            showCurrency
          />
        </>
      )}
      <BookingSummaryCategorySection
        name="Final balance"
        netPrice={balance}
        showNetPrice
        bold
        currency={currency}
        showCurrency
      />
      <S.BookingSummaryCategoryParagraph>
        Final balance price includes {taxCode} of {currency}
        {currencySymbol}
        {numberToDecimalString(taxAmount)}
      </S.BookingSummaryCategoryParagraph>
      {!hideDynamicLiability && liability !== null && liability !== undefined && (
        <S.BookingSummaryCategoryParagraph>
          You are liable for up to{' '}
          <strong>
            {currencySymbol}
            {numberToDecimalString(liability)}
          </strong>{' '}
          per incident (subject to exclusions - refer to rental agreement).
          {countryCode === CountryCode.AU && (
            <>
              {' '}
              Deposit of{' '}
              <strong>
                {currencySymbol}
                {numberToDecimalString(liability)}
              </strong>{' '}
              required.
            </>
          )}
        </S.BookingSummaryCategoryParagraph>
      )}
    </S.BookingSummaryCategoryContainer>
  );
};
